import React from "react";
// material
import { useTheme } from "@mui/material/styles";
import { Box, SxProps } from "@mui/material";

type Props = {
  sx?: SxProps;
};

export default function Logo({ sx }: Props) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const styles = {
    st0: {
      fill: PRIMARY_MAIN,
      stroke: PRIMARY_MAIN,
      strokeWidth: 5.2577,
      strokeMiterlimit: 10,
    },
    st1: {
      fill: PRIMARY_MAIN,
      stroke: PRIMARY_MAIN,
      strokeWidth: 31.5461,
      strokeMiterlimit: 10,
    },
  };

  return (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      {/* <img src="/static/wide_logo.png" alt="" /> */}
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 980 980"
        xmlSpace="preserve"
      >
        <g>
          <g>
            <path
              style={styles.st0}
              d="M488.2,800.9c-176.4,0-319.9-143.5-319.9-319.9c0-176.4,143.5-319.9,319.9-319.9
			C664.6,161.1,808,304.6,808,481C808,657.4,664.6,800.9,488.2,800.9z M488.2,163.3C313,163.3,170.4,305.8,170.4,481
			c0,175.2,142.5,317.7,317.7,317.7c175.2,0,317.7-142.5,317.7-317.7C805.9,305.8,663.4,163.3,488.2,163.3z"
            />
            <path
              style={styles.st1}
              d="M813.4,481h-12.7c0-76.2-27.7-149.5-78-206.6l9.6-8.4C784.5,325.4,813.4,401.7,813.4,481z"
            />
            <path
              style={styles.st1}
              d="M294.3,236l-7.9-10c57.9-45.9,127.7-70.1,201.8-70.1v12.7C417,168.6,350,191.9,294.3,236z"
            />
            <path
              style={styles.st1}
              d="M244.3,696C191.9,636.7,163,560.3,163,481h12.7c0,76.2,27.7,149.6,78.1,206.6L244.3,696z"
            />
            <path
              style={styles.st1}
              d="M488.2,806.2v-12.7c86,0,166.1-34.2,225.6-96.2l9.2,8.8C661,770.6,577.6,806.2,488.2,806.2z"
            />
          </g>
          <g>
            <path
              style={styles.st0}
              d="M488.3,869.1c-104.5,0-208.6-41.8-285.1-124.3c-145.5-157.1-136-403.3,21.1-548.7
			C300.5,125.6,399.5,89,503.1,93c103.6,4,199.5,48.1,270,124.2c70.5,76.1,107.1,175.1,103.1,278.7c-4,103.6-48.1,199.5-124.2,270
			C677.4,835,582.7,869.1,488.3,869.1z M487.8,95c-97.5,0-189.9,36.2-261.9,102.8C69.8,342.4,60.4,587.1,205,743.2
			c144.6,156.2,389.3,165.6,545.5,21c75.7-70,119.5-165.4,123.5-268.4c4-103-32.4-201.4-102.5-277.1
			C701.4,143.1,606.1,99.3,503,95.3C498,95.1,492.9,95,487.8,95z"
            />
            <path
              style={styles.st1}
              d="M767.2,222.7c-63-68-148.4-110.6-240.5-120l1.4-13.7c95.5,9.7,184,53.8,249.2,124.3L767.2,222.7z"
            />
            <path
              style={styles.st1}
              d="M112.4,422.4l-13.6-2.1c13.7-88.5,55.8-167.5,121.6-228.5l9.3,10.1C166.3,260.8,125.7,337,112.4,422.4z"
            />
            <path
              style={styles.st1}
              d="M448.3,873c-95.5-9.7-184-53.8-249.3-124.3l10.1-9.3c63,68,148.4,110.6,240.6,120L448.3,873z"
            />
            <path
              style={styles.st1}
              d="M755.9,770.1l-9.3-10.1c76.8-71.1,120-167.8,121.9-272.5l13.8,0.2C880.3,596.2,835.4,696.5,755.9,770.1z"
            />
          </g>
        </g>
      </svg>
    </Box>
  );
}
